import { QuerySwitch } from 'components/QuerySwitch';
import {
  ShiftModalDataContext,
  useShiftModalDataContext,
} from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { AuditTrailDetailTabView } from 'modals/ShiftModal/src/views/DetailView/AuditTrailDetailView/AuditTrailDetailTabView';
import { DetailTabView } from 'modals/ShiftModal/src/views/DetailView/DetailTabView/DetailTabView';
import { IDetailViewComponentProps } from 'modals/ShiftModal/src/views/DetailView/DetailView.types';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { isAuditTrailFeatureEnabledForCommunitySelector } from 'store/selectors/featureFlagSelectors';
import { ShiftModalErrorView } from 'modals/ShiftModal/src/views/ShiftModalErrorView';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';

export const DetailViewComponent: FC<IDetailViewComponentProps> = (values) => {
  const { data } = useShiftModalDataContext();
  const order = data?.order;
  const { hasMarketplace, value } = getCurrentlySelectedLocation();

  const isAuditTrailEnabled = useSelector(
    isAuditTrailFeatureEnabledForCommunitySelector({
      communityId: hasMarketplace ? Number(value) : order?.community.id,
      auditTrailVersion: order?.auditTrailVersion,
    }),
  );
  return isAuditTrailEnabled ? (
    <AuditTrailDetailTabView {...values} />
  ) : (
    <DetailTabView {...values} />
  );
};

export const DetailView: FC = () => {
  return (
    <QuerySwitch
      component={DetailViewComponent}
      context={ShiftModalDataContext}
      errorComponent={ShiftModalErrorView}
    />
  );
};
